import { withLoginUser } from 'src/api/user'
import { AuthService } from 'src/services/AuthService'
import { PasswordForm } from './PasswordForm'

export const PasswordEditor = withLoginUser(({ user }) => (
  <PasswordForm user={user} submit={AuthService.changePassword} />
))
